<script setup lang="ts">
const props = defineProps<{
  active: boolean
  txt: stringI18n
  txtAfter?: stringI18n
  onClick: () => void

  right: boolean | None
  button: boolean | None
}>()

const mobile = useMobile()
const css = useCssModule()
const classLink = computed(() => {
  const res = [css.link]
  if (props.right) res.push('_mr1')
  return res
})
</script>

<template>
  <div v-bind="$attrs" :class="[(button || mobile) && $style.button, $style.aggree, 'IconSwitch', { on: active }]">
    <button type="button" class="_absolute _inset" :class="$style.z2" @click="() => onClick()" @keypress.enter="() => onClick()" />

    <div class="_hm28" :class="right && '_pr8'">
      <span v-if="!right"><IconSwitch /></span>

      <span class="_wmin0" :class="[$style.label, !right && '_ml06']"
        >{{ txt }}<span v-if="txtAfter" :class="$style.label" class="_italic">&nbsp;&nbsp;({{ txtAfter }})</span></span
      >
      <slot name="after" :class-link />
      <span v-if="right" :class="$style.right" class="_absolute"><IconSwitch /></span>
    </div>

    <slot />
  </div>
</template>

<style module>
.aggree {
  composes: global(_relative);
  composes: global(_col);
  composes: global(_fs09);
  composes: global(_lh12);
  composes: global(_fw-l);
  composes: global(_ls-xs);

  composes: global(_c1);
  composes: global(_ws_pre);

  z-index: 0;
  cursor: pointer;
}
.aggree:disabled {
  cursor: not-allowed;
  background: var(--black-6);
  color: var(--black-4);
  border-color: var(--black-5);
}
.button {
  composes: global(_br14);
  composes: global(_wrap);
  composes: global(_b5);

  composes: global(d_pt08);
  composes: global(d_pl08);
  composes: global(d_pr08);
  composes: global(d_pb08);

  composes: global(m_pt1);
  composes: global(m_pb1);
  composes: global(m_pl08);
  composes: global(m_pr08);

  composes: global(_bg0);
}
:global(.d) .button:hover {
  background: var(--black-6);
}

.right {
  top: 10px;
  right: 10px;
}

.label {
  composes: global(_noflex);
  composes: global(_txt_inline);
}

.link {
  composes: global(_cb3);
  composes: global(_noflex);
  composes: global(_fs09);
  composes: global(_ml04);
  align-self: center;
  z-index: 3;
}
:global(.d) .link:hover {
  color: var(--blue2);
}
.z2 {
  z-index: 2;
}
</style>
